import Peg from "./Peg";

const Row = ({currentColors}) => {

  return (
    <div className="rowSolution">
      {(currentColors.map((col,j) => <Peg pegColor={col} id={`${j}`} key={`${j}`} />))}
    </div>
  );
}

export default Row;